// AUTO-GENERATED by scripts/generate-tokens.mjs — DO NOT EDIT.
// Source of truth: src/theme/design-tokens.generated.json (key: zoneColors)
//   <- beoflow-design-tokens-sync (Drafted "Beoflow Design System" / foundations/zoneColors)
// Regenerate: npm run tokens:gen   (no-drift gate: npm run tokens:check)
//
// The .generated suffix means DO NOT HAND-EDIT. These are the Beoflow HR/intensity zone colors.
// Mirrors the iOS Beoflow/Theme/ files; values are web-idiomatic (hex/rgba, numeric weights, px).

export const zoneColors = {
  z0: '#DCDCDC',
  z1: '#20586E',
  z2: '#86BED4',
  z3: '#FFDFD4',
  z4: '#FFAE94',
  z5: '#FF5D29',
  z6: '#D63A0A',
  z7: '#834963',
} as const;
export type BeoflowZoneName = keyof typeof zoneColors;

/** Label per zone (from iOS Color+HRZone). */
export const zoneColorMeta = {
  z0: { name: 'Z0', label: 'Recovery' },
  z1: { name: 'Z1', label: 'Endurance' },
  z2: { name: 'Z2', label: 'Tempo' },
  z3: { name: 'Z3', label: 'Threshold' },
  z4: { name: 'Z4', label: 'VO2 Max' },
  z5: { name: 'Z5', label: 'Anaerobic' },
  z6: { name: 'Z6', label: 'Neuromuscular' },
  z7: { name: 'Z7', label: 'Max Effort' },
} as const;

/** Zone color by numeric index 0..7 — mirrors iOS Color.hrZone(_:). */
export const zoneColorByIndex = ['#DCDCDC', '#20586E', '#86BED4', '#FFDFD4', '#FFAE94', '#FF5D29', '#D63A0A', '#834963'] as const;
export function hrZoneColor(zone: number): string {
  return zoneColorByIndex[zone] ?? zoneColors.z0;
}
